import React from "react";
import type { DocumentElement as DocumentElementType } from "@eaco/forms-core";

import { useIsEditor } from "../DocumentView/DocumentContext";
import HiddenElementBanner from "./HiddenElementBanner";
import ArchivedElementBanner from "./ArchivedElementBanner";

interface Props {
  element: DocumentElementType;
}

const SIZE_PX: Record<string, number> = { small: 24, medium: 40, large: 64 };
// Map legacy size keys (sm/md/lg/xl) onto the new small/medium/large scale.
const LEGACY: Record<string, string> = {
  sm: "small",
  md: "medium",
  lg: "large",
  xl: "large",
};

const Spacer: React.FC<Props> = ({ element }) => {
  const data = element.data as { size?: string; hidden?: boolean };
  const raw = data?.size || "small";
  const size = LEGACY[raw] || (SIZE_PX[raw] ? raw : "small");
  const px = SIZE_PX[size] ?? SIZE_PX.small;
  const isEditor = useIsEditor();

  return (
    <div className="space-y-2">
      {isEditor ? (
        // Design mode: render the reserved gap as a visible, labelled
        // placeholder so designers can see and select it on the canvas.
        <div
          style={{
            height: px,
            border: "1.4px dashed #dfe3e9",
            borderRadius: 9,
            background:
              "repeating-linear-gradient(45deg,#fafbfc,#fafbfc 7px,#f2f4f7 7px,#f2f4f7 14px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span style={{ fontSize: 11, fontWeight: 600, color: "#aab2bd" }}>
            Spacer · {size.charAt(0).toUpperCase() + size.slice(1)}
          </span>
        </div>
      ) : (
        // Fill / view: just the empty gap.
        <div style={{ height: px }} />
      )}
      <HiddenElementBanner hidden={data?.hidden} />
      <ArchivedElementBanner archived={element.archived} />
    </div>
  );
};

export default Spacer;
